
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as AddIconComponent } from "./add-icon.svg";

export const AddIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <AddIconComponent {...props} />;
};
